var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowseChargers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 66,
    viewBox: "0 0 52 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.9998,
    y: 22,
    width: 12,
    height: 17,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4641 43.0625H19.5332V48.6428H23.3828V71.5H28.6161V48.6428H32.4641V43.0625Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3518 16.6122H36.9906V3.49305C36.9906 2.13345 35.9051 1.03125 34.5661 1.03125C33.2271 1.03125 32.1416 2.13345 32.1416 3.49305V16.6122H19.8566V3.49305C19.8566 2.13345 18.7711 1.03125 17.4321 1.03125C16.0923 1.03125 15.0076 2.13345 15.0076 3.49305V16.6122H7.64795V22.1966H10.3292V32.2658C10.3292 37.3246 14.3681 41.4257 19.3496 41.4257H32.6478C37.63 41.4257 41.6681 37.3246 41.6681 32.2658V22.1975H44.351V16.6122H44.3518ZM22.7215 37.7594L24.2953 30.8657H22.0869L23.6599 23.972L29.544 24.0331L26.9383 30.8657H29.9113L22.7215 37.7594Z",
    fill: "#626262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 66,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseChargers);
export default __webpack_public_path__ + "static/media/browse-chargers.931cb7f91c3b1730b90b6bccf10aa9d9.svg";
export { ForwardRef as ReactComponent };